import { api } from "./client";
import type { DriveContainer } from "./driveContainers";
export interface CourseDriveCourse {
  course_id: string;
  code: string;
  title: string;
  title_ar: string | null;
  crn: string | null;
  status: string;
  href: string;
  can_create: boolean;
  term: { name: string; status: string } | null;
  containers: DriveContainer[];
}
export interface CourseDriveRegister {
  generated_at: string;
  availability: "enabled" | "disabled" | "configuration_pending";
  shell_base: string;
  courses: CourseDriveCourse[];
}
export const courseDriveQueryKey = ["teaching", "drive-folders"] as const;
export const courseDriveApi = {
  get: () => api.get<CourseDriveRegister>("/workspaces/teaching/drive-folders"),
};
